import {FontType} from '../models/enum/shared/font-type.enum';
import {Font} from '../models/enum/shared/font.enum';

/**
 * When adding a new font, it needs to be added here, and in _font.scss
 */
export class FontUtils {

  static getAllFontTypes(): Font[] {
    return [Font.WorkSans, Font.Rajdhani];
  }

  static getFontClass(type: FontType, font: Font): string {
    switch (font) {
      case Font.WorkSans: return FontUtils.getWorkSansFontClass(type);
      case Font.Rajdhani: return FontUtils.getRajdhaniFontClass(type);
      default:            return FontUtils.getWorkSansFontClass(type);
    }
  }

  static getWorkSansFontClass(type: FontType): string {
    switch (type) {
      case FontType.Default:   return 'work-sans';
      case FontType.Light:     return 'work-sans-light';
      case FontType.Regular:   return 'work-sans-regular';
      case FontType.Medium:    return 'work-sans-medium';
      case FontType.SemiBold:  return 'work-sans-semi-bold';
      case FontType.Bold:      return 'work-sans-bold';
      case FontType.ExtraBold: return 'work-sans-extra-bold';
    }
  }

  static getRajdhaniFontClass(type: FontType): string {
    switch (type) {
      case FontType.Default:   return 'rajdhani';
      case FontType.Light:     return 'rajdhani-light';
      case FontType.Regular:   return 'rajdhani-regular';
      case FontType.Medium:    return 'rajdhani-medium';
      case FontType.SemiBold:  return 'rajdhani-semi-bold';
      case FontType.Bold:      return 'rajdhani-bold';
      case FontType.ExtraBold: return 'rajdhani-extra-bold';
    }
  }

}
